import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Component, computed, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';

@Component({
  selector: 'select-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MaterialModule, TranslatePipe],
  templateUrl: './select-field.component.html',
})
export class SelectFieldComponent {
  label = input.required<string>();
  control = input.required<FormControl>();
  options = input.required<any[]>();
  optionLabel = input<string>('nombre');
  optionValue = input<string>('id');
  multiple = input<boolean>(false);
  filter = input<boolean>(false);
  // Señal interna para el texto de búsqueda
  searchText = signal<string>('');
  name = input<string>();
  /** Texto cuando no hay valor. */
  placeholder = input<string>();
  /** @deprecated El panel usa CDK; no aplica. Se mantiene por compatibilidad. */
  appendTo = input<string | HTMLElement | undefined>(undefined);
  /** Clases extra para el panel del mat-select (p. ej. tema). */
  panelStyleClass = input<string | undefined>(undefined);
  readonly filteredOptions = computed(() => {
    const search = this.searchText().toLowerCase();
    const allOptions = this.options() || [];
    
    if (!this.filter() || !search) return allOptions;

    return allOptions.filter(opt => 
      this.readLabel(opt).toLowerCase().includes(search)
    );
  });
  stopPropagation(event: KeyboardEvent): void {
    event.stopPropagation();
  }
  handleSearch(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchText.set(input.value);
  }
  readonly panelClasses = computed(() => {
    const base = 'personas-select-panel';
    const extra = this.panelStyleClass()?.trim();
    return extra ? `${base} ${extra}` : base;
  });

  readLabel(opt: unknown): string {
    const key = this.optionLabel();
    if (opt === null || opt === undefined) return '';
    const o = opt as Record<string, unknown>;
    const v = o[key];
    return v !== undefined && v !== null ? String(v) : '';
  }

  readValue(opt: unknown): string | number | boolean {
    const key = this.optionValue();
    if (opt === null || opt === undefined) {
      return '';
    }
    const o = opt as Record<string, unknown>;
    const v = o[key];
    if (typeof v === 'boolean' || typeof v === 'number') return v;
    if (v === null || v === undefined) return '';
    return v as string | number | boolean;
  }

  trackKey(index: number, opt: unknown): string | number | boolean {
    const v = this.readValue(opt);
    if (v === '' && typeof opt === 'object' && opt !== null) {
      return index;
    }
    return v === '' ? index : v;
  }
}
